import { render, staticRenderFns } from "./FormCreateNote.vue?vue&type=template&id=2638f680&"
import script from "./FormCreateNote.vue?vue&type=script&lang=ts&"
export * from "./FormCreateNote.vue?vue&type=script&lang=ts&"
import style0 from "./FormCreateNote.vue?vue&type=style&index=0&id=2638f680&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports